import { defineMessages } from 'dibs-react-intl';

export const pdpDimensionMessages = defineMessages({
    height: {
        id: 'abf.PdpRespSimilarSoldItemsColumn.dimensions.height',
        defaultMessage: 'H',
    },
    width: {
        id: 'abf.PdpRespSimilarSoldItemsColumn.dimensions.width',
        defaultMessage: 'W',
    },
    depth: {
        id: 'abf.PdpRespSimilarSoldItemsColumn.dimensions.depth',
        defaultMessage: 'D',
    },
    secondaryHeight: {
        id: 'abf.PdpRespSimilarSoldItemsColumn.dimensions.secondaryHeight',
        defaultMessage: 'Seat Height',
    },
    diameter: {
        id: 'abf.PdpRespSimilarSoldItemsColumn.dimensions.diameter',
        defaultMessage: 'Diameter',
    },
    length: {
        id: 'abf.PdpRespSimilarSoldItemsColumn.dimensions.length',
        defaultMessage: 'L',
    },
});
